import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  bbbEnabledMock,
  checkEventTutorMock,
  getEventDetailsMock,
  getSessionsListMock,
  getUsersBySessionMock,
  joinBBBSessionMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import {
  BBBEventsPath,
  activitySessionPath,
  eventsPath,
} from '../../utils/paths';

export default {
  sessionsListGet: (filters) => {
    if (shouldUseMock()) {
      return getSessionsListMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getEventDetails: (id) => {
    if (shouldUseMock()) {
      return getEventDetailsMock();
    }
    return apiCall(`${baseUrl}${eventsPath}event/${id}/details`, 'GET');
  },
  sessionRegistration: (session_id, activity_id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${activitySessionPath}session/${session_id}/activity/${activity_id}/registration `,
      'POST',
      {}
    );
  },
  checkEventTutor: ({ sessionId }) => {
    if (shouldUseMock()) {
      return checkEventTutorMock();
    }
    return apiCall(
      `${baseUrl}${eventsPath}session/${sessionId}/tutor/check`,
      'GET'
    );
  },
  getUsersBySession: ({ sessionId }) => {
    if (shouldUseMock()) {
      return getUsersBySessionMock();
    }
    return apiCall(
      `${baseUrl}${eventsPath}session/${sessionId}/users/list`,
      'GET'
    );
  },
  addUserToSession: ({ userId, sessionId }) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${eventsPath}session/${sessionId}/user/${userId}/force/registration`,
      'POST',
      {
        action: true,
      }
    );
  },
  joinBBBSession: (id) => {
    if (shouldUseMock()) {
      return joinBBBSessionMock();
    }
    return apiCall(`${baseUrl}${BBBEventsPath}session/${id}/join`, 'GET');
  },
  bbbEnabledGet: () => {
    if (shouldUseMock()) {
      return bbbEnabledMock();
    }
    return apiCall(`${baseUrl}${BBBEventsPath}toggle`, 'GET');
  },
  bbbUrlGet: (title) => {
    if (shouldUseMock()) {
      return joinBBBSessionMock();
    }
    return apiCall(`${baseUrl}${BBBEventsPath}meeting/create`, 'POST', {
      activity_title: title,
    });
  },
};
